
/**
 *
 *  Helper Functions for handling Drupal Endpoint and response data
 *
 */

//import he from 'he';


module.exports = {
  //getField,
  //getItemPhotos,
  getError,
  constructBasicPut,
  constructBasicPost,
  constructCustomPutField,
  //decodeHTMLEntities,
}





function constructCustomPutField(fieldName, key, value) {
  let temp = {};
  temp[`field_${fieldName}`] = { "und": [{ [`${key}`]: value }] };
  return temp;
}

function constructBasicPost(data) {
  let post = {};
  Object.keys(data).forEach(key => {
    post[`field_${key}`] = { "und": [{ "value": data[key] }] };
  });
  return post;
}

function constructBasicPut(data) {
  let put = {};
  Object.keys(data).forEach(key => {
    put[`field_${key}`] = { "und": [{ "value": data[key] }] };
  });
  return put;
}


function getError(response, defaultErrMessage = "An error occurred, Please try again.") {

  // if no response data ( errors ) returned
  // show default error message
  if(!response || !response.data) {
    //return JSON.stringify(response);
    return defaultErrMessage;
  }

  // check for form errors in response
  if(response.data.form_errors) {
    for (var error in response.data.form_errors) {
      if (response.data.form_errors.hasOwnProperty(error)) {
        return stripHtml(response.data.form_errors[error]);
      }
    }
  }

  //check for another type of error in response
  if(response.data.error && response.data.error_description) {
    return response.data.error_description;
  }

  // Return normal response error
  return response.data[0];

}

// function decodeHTMLEntities(str) {
//   return he.decode(str);
// }

function stripHtml(html) {
  return html.replace(/<(?:.|\n)*?>/gm, '');
}



// WEBPACK FOOTER //
// ./src/utils/drupal.js